

// Function to handle PDF download
export const handleDownloadPdf = () => {
  const downloadLink = document.createElement("a");
  downloadLink.href = '/TRAMPTEC_Каталог.pdf'; // Path to the file
  downloadLink.download = "TRAMPTEC_Каталог.pdf"; // File name
  downloadLink.click();
};
